import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import * as Agency from "../index";
import {
    AgencyPrepareEditFormResponse
} from "../../../types/modules/agency/response";
import {StoreContext} from "../../../store.context";

export const Edit: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { agencyStore: { edit }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();
    const params = useParams();

    const data: AgencyPrepareEditFormResponse = useLoaderData() as AgencyPrepareEditFormResponse;

    const onCancel = () => {
        navigate(`/agency`)
    }

    return <Agency.Form onSave={(values) => { return edit({...values, id: params.id}) }} onCancel={onCancel} preparedData={data} />
})